import CustomModal from './customModal';
import styles from '../css/promoCodeAddedModal.module.scss';
import { useTranslation } from 'react-i18next';

const PromoCodeDeletingModal = ({ isOpen, onClose, onConfirm }: { isOpen: boolean; onClose: () => void; onConfirm: () => void }) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      closeButton
    >
      <div className={styles.wrap}>
        <p className={styles.title}>{t('promoCodeDeleteModal.title')}</p>
        <div>
          <p style={{ textAlign: 'center' }}>{t('promoCodeDeleteModal.message')}</p>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => {
              onClose();
            }}
            className="primaryButton inverse"
          >
            {t('promoCodeDeleteModal.cancel')}
          </button>
          <button
            onClick={() => {
              onConfirm();
            }}
            className="primaryButton"
          >
            {t('promoCodeDeleteModal.confirm')}
          </button>
        </div>
      </div>
    </CustomModal>
  );
};
export default PromoCodeDeletingModal;
